// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  height: 100%;
}

.sold-out {
  position: absolute;
  left: 25px;
  top: 10px;
  z-index: 9999;
}
.sold-out ion-icon {
  height: 30px;
  width: 66px;
  z-index: 99;
}

.item-row {
  height: 100%;
  border-radius: 35px;
  padding: 19px 7% 28px;
  position: relative;
  overflow: hidden;
  transition: border 0.2s ease-in-out;
  background: #f6f1ef;
  border: 1px solid #000000;
  cursor: pointer;
}
.item-row.inactive {
  opacity: 0.3;
}
.item-row.isAdded {
  border: 1px solid var(--color-black);
}
@media (min-width: 991px) {
  .item-row:hover {
    border: 1px solid #272727;
  }
}

.item-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.new {
  position: absolute;
  height: 25px;
  width: 60px;
  background-color: var(--ion-color-primary);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  top: -8px;
  right: -5px;
  z-index: 1;
  color: #f6f1ef;
  text-transform: uppercase;
  font-size: 80%;
}

.img-wrapper {
  width: 100%;
  height: 250px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  margin-bottom: 10px;
  margin-top: 35px;
}
.img-wrapper.block-adding ion-img {
  opacity: 0.3;
}
.img-wrapper.block-adding ion-icon {
  position: absolute;
  top: 10px;
  right: -15px;
  transform: translate(-50%, -50%);
  z-index: 99;
  width: 25px;
  height: 25px;
  opacity: 0.3;
}

.item-image {
  width: 280px;
  height: 250px;
  max-width: 100%;
  object-fit: contain;
  display: block;
  border-radius: 8px;
}

.default-image {
  width: 280px;
  height: 250px;
  max-width: 100%;
  --icon-color: var(--color-black);
}

.item-name {
  font-family: Title;
  font-size: 32px;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  color: var(--color-black);
  margin-bottom: 5px;
}

.item-info {
  font-family: AppFont;
  font-size: 10px;
  line-height: 150%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  color: var(--color-black);
  margin-bottom: 15px;
}

.price-row {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}
.price-row .price {
  font-family: Title;
  font-size: 24px;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  color: var(--color-black);
}
.price-row .kcall {
  position: relative;
  font-size: 14px;
  line-height: 16.8px;
  letter-spacing: 0%;
  text-align: center;
  text-transform: uppercase;
}
.price-row .kcall,
.price-row .tags {
  position: relative;
  height: 17px;
  margin-left: 12px;
}
.price-row .kcall::before,
.price-row .tags::before {
  content: "";
  position: absolute;
  left: -6px;
  width: 1.5px;
  height: 100%;
  background: var(--color-black);
}

.buttons {
  margin-top: auto;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}
.buttons ion-button {
  width: 50%;
  height: 36px;
}
.buttons .add-button {
  --background: var(--ion-color-primary);
  --color: white;
  min-height: 30px !important;
  height: 30px !important;
}
.buttons .add-button.not-enought {
  opacity: 0.3;
}
.buttons .add-icon-wrap {
  width: 48%;
  display: flex;
  justify-content: flex-start;
}
.buttons .add-icon-wrap.center-align {
  justify-content: center;
}
.buttons .not-enough {
  --color: var(--color-black);
  opacity: 0.5;
}
.buttons .not-enough ion-icon {
  margin-right: 10px;
}

.progress-bar {
  position: absolute;
  bottom: -20px;
  width: 120%;
  --progress-background: #f48b7f;
  --buffer-background: #ebdfda;
}

.add-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #ebdfda;
}
.add-icon:hover {
  background: #f2dbd9;
}
.add-icon ion-icon {
  margin: 0px;
  color: var(--color-black);
  width: 40px;
  height: 40px;
}

.amount-in-basket {
  position: absolute;
  display: flex;
  align-items: center;
  border-radius: 20px;
  top: 20px;
  right: 20px;
  width: -moz-fit-content;
  width: fit-content;
  margin: 0 auto;
}
.amount-in-basket .selected-text {
  font-family: AppFontBold;
  font-size: 10px;
  line-height: 85%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: lowercase;
  color: var(--color-black);
  margin-right: 4px;
}
.amount-in-basket .quantity-block {
  height: 24px;
  width: 48px;
  background: #000000;
  border: 1px solid;
  border-radius: 50px;
  border-image-source: linear-gradient(0deg, #ffffff, #ffffff), linear-gradient(0deg, #ffffff, #ffffff);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.amount-in-basket .quantity-block .quantity {
  font-family: Title;
  font-weight: 400;
  font-size: 20px;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  color: var(--color-white);
  transform: translate(10px, -3%);
}
.amount-in-basket .quantity-block .checkmark {
  height: 24px;
  width: 24px;
  position: relative;
  left: 2px;
  scale: 1.03;
}`, "",{"version":3,"sources":["webpack://./src/app/components/item-view/item-view.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,cAAA;EACA,YAAA;AADD;;AAGA;EACC,kBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;AAAD;AACC;EACC,YAAA;EACA,WAAA;EACA,WAAA;AACF;;AAEA;EACC,YAAA;EAEA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mCAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AAAD;AAEC;EACC,YAAA;AAAF;AAEC;EACC,oCAAA;AAAF;AChCE;EDmCA;IACC,yBAAA;EAAD;AACF;;AAIA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AADD;;AAIA;EACC,kBAAA;EACA,YAAA;EACA,WAAA;EACA,0CAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EAEA,SAAA;EACA,WAAA;EACA,UAAA;EACA,cAAA;EACA,yBAAA;EACA,cAAA;AAFD;;AAIA;EACC,WAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AADD;AAGE;EACC,YAAA;AADH;AAGE;EACC,kBAAA;EACA,SAAA;EACA,YAAA;EACA,gCAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AADH;;AAKA;EACC,YAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AAFD;;AAKA;EACC,YAAA;EACA,aAAA;EACA,eAAA;EACA,gCAAA;AAFD;;AAKA;EACC,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,yBAAA;EAEA,kBAAA;AAHD;;AAMA;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EAEA,mBAAA;AAJD;;AAOA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,mBAAA;AALD;AAOC;EACC,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,yBAAA;AALF;AAQC;EACC,kBAAA;EAEA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;AAPF;AASC;;EAEC,kBAAA;EACA,YAAA;EACA,iBAAA;AAPF;AAUC;;EAEC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,8BAAA;AARF;;AAYA;EACC,gBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AATD;AAWC;EACC,UAAA;EACA,YAAA;AATF;AAWC;EACC,sCAAA;EACA,cAAA;EACA,2BAAA;EACA,uBAAA;AATF;AAUE;EACC,YAAA;AARH;AAWC;EACC,UAAA;EACA,aAAA;EACA,2BAAA;AATF;AAUE;EACC,uBAAA;AARH;AAWC;EACC,2BAAA;EACA,YAAA;AATF;AAUE;EACC,kBAAA;AARH;;AAYA;EACC,kBAAA;EACA,aAAA;EACA,WAAA;EACA,8BAAA;EACA,4BAAA;AATD;;AAWA;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AARD;AASC;EACC,mBAAA;AAPF;AASC;EACC,WAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;AAPF;;AAUA;EACC,kBAAA;EACA,aAAA;EACA,mBAAA;EAEA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EAAA,kBAAA;EACA,cAAA;AARD;AAUC;EACC,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,yBAAA;EAEA,iBAAA;AATF;AAYC;EACC,YAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qGAAA;EAEA,aAAA;EACA,8BAAA;EACA,mBAAA;AAXF;AAaE;EACC,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,yBAAA;EAEA,+BAAA;AAZH;AAeE;EACC,YAAA;EACA,WAAA;EAEA,kBAAA;EACA,SAAA;EACA,WAAA;AAdH","sourcesContent":["@import '../../../theme/mixins';\n\n:host {\n\tdisplay: block;\n\theight: 100%;\n}\n.sold-out {\n\tposition: absolute;\n\tleft: 25px;\n\ttop: 10px;\n\tz-index: 9999;\n\tion-icon {\n\t\theight: 30px;\n\t\twidth: 66px;\n\t\tz-index: 99;\n\t}\n}\n.item-row {\n\theight: 100%;\n\n\tborder-radius: 35px;\n\tpadding: 19px 7% 28px;\n\tposition: relative;\n\toverflow: hidden;\n\ttransition: border 0.2s ease-in-out;\n\tbackground: #f6f1ef;\n\tborder: 1px solid #000000;\n\tcursor: pointer;\n\n\t&.inactive {\n\t\topacity: 0.3;\n\t}\n\t&.isAdded {\n\t\tborder: 1px solid var(--color-black);\n\t}\n\t@include desktop {\n\t\t&:hover {\n\t\t\tborder: 1px solid #272727;\n\t\t}\n\t}\n}\n\n.item-col {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.new {\n\tposition: absolute;\n\theight: 25px;\n\twidth: 60px;\n\tbackground-color: var(--ion-color-primary);\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tborder-radius: 50px;\n\n\ttop: -8px;\n\tright: -5px;\n\tz-index: 1;\n\tcolor: #f6f1ef;\n\ttext-transform: uppercase;\n\tfont-size: 80%;\n}\n.img-wrapper {\n\twidth: 100%;\n\theight: 250px;\n\tposition: relative;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tborder-radius: 12px;\n\tmargin-bottom: 10px;\n\tmargin-top: 35px;\n\t&.block-adding {\n\t\tion-img {\n\t\t\topacity: 0.3;\n\t\t}\n\t\tion-icon {\n\t\t\tposition: absolute;\n\t\t\ttop: 10px;\n\t\t\tright: -15px;\n\t\t\ttransform: translate(-50%, -50%);\n\t\t\tz-index: 99;\n\t\t\twidth: 25px;\n\t\t\theight: 25px;\n\t\t\topacity: 0.3;\n\t\t}\n\t}\n}\n.item-image {\n\twidth: 280px;\n\theight: 250px;\n\tmax-width: 100%;\n\tobject-fit: contain;\n\tdisplay: block;\n\tborder-radius: 8px;\n}\n\n.default-image {\n\twidth: 280px;\n\theight: 250px;\n\tmax-width: 100%;\n\t--icon-color: var(--color-black);\n}\n\n.item-name {\n\tfont-family: Title;\n\tfont-size: 32px;\n\tline-height: 120%;\n\tletter-spacing: 0%;\n\ttext-align: center;\n\tvertical-align: middle;\n\ttext-transform: uppercase;\n\tcolor: var(--color-black);\n\n\tmargin-bottom: 5px;\n}\n\n.item-info {\n\tfont-family: AppFont;\n\tfont-size: 10px;\n\tline-height: 150%;\n\tletter-spacing: 0%;\n\ttext-align: center;\n\tvertical-align: middle;\n\tcolor: var(--color-black);\n\n\tmargin-bottom: 15px;\n}\n\n.price-row {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\n\tmargin-bottom: 20px;\n\n\t.price {\n\t\tfont-family: Title;\n\t\tfont-size: 24px;\n\t\tline-height: 120%;\n\t\tletter-spacing: 0%;\n\t\ttext-align: center;\n\t\tvertical-align: middle;\n\t\ttext-transform: uppercase;\n\t\tcolor: var(--color-black);\n\t}\n\n\t.kcall {\n\t\tposition: relative;\n\n\t\tfont-size: 14px;\n\t\tline-height: 16.8px;\n\t\tletter-spacing: 0%;\n\t\ttext-align: center;\n\t\ttext-transform: uppercase;\n\t}\n\t.kcall,\n\t.tags {\n\t\tposition: relative;\n\t\theight: 17px;\n\t\tmargin-left: 12px;\n\t}\n\n\t.kcall::before,\n\t.tags::before {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\tleft: -6px;\n\t\twidth: 1.5px;\n\t\theight: 100%;\n\t\tbackground: var(--color-black);\n\t}\n}\n\n.buttons {\n\tmargin-top: auto;\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tgap: 8px;\n\n\tion-button {\n\t\twidth: 50%;\n\t\theight: 36px;\n\t}\n\t.add-button {\n\t\t--background: var(--ion-color-primary);\n\t\t--color: white;\n\t\tmin-height: 30px !important;\n\t\theight: 30px !important;\n\t\t&.not-enought {\n\t\t\topacity: 0.3;\n\t\t}\n\t}\n\t.add-icon-wrap {\n\t\twidth: 48%;\n\t\tdisplay: flex;\n\t\tjustify-content: flex-start;\n\t\t&.center-align {\n\t\t\tjustify-content: center;\n\t\t}\n\t}\n\t.not-enough {\n\t\t--color: var(--color-black);\n\t\topacity: 0.5;\n\t\tion-icon {\n\t\t\tmargin-right: 10px;\n\t\t}\n\t}\n}\n.progress-bar {\n\tposition: absolute;\n\tbottom: -20px;\n\twidth: 120%;\n\t--progress-background: #f48b7f;\n\t--buffer-background: #ebdfda;\n}\n.add-icon {\n\twidth: 40px;\n\theight: 40px;\n\tborder-radius: 50%;\n\tbackground: #ebdfda;\n\t&:hover {\n\t\tbackground: #f2dbd9;\n\t}\n\tion-icon {\n\t\tmargin: 0px;\n\t\tcolor: var(--color-black);\n\t\twidth: 40px;\n\t\theight: 40px;\n\t}\n}\n.amount-in-basket {\n\tposition: absolute;\n\tdisplay: flex;\n\talign-items: center;\n\n\tborder-radius: 20px;\n\ttop: 20px;\n\tright: 20px;\n\twidth: fit-content;\n\tmargin: 0 auto;\n\n\t.selected-text {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 10px;\n\t\tline-height: 85%;\n\t\tletter-spacing: 0%;\n\t\ttext-align: center;\n\t\tvertical-align: middle;\n\t\ttext-transform: lowercase;\n\t\tcolor: var(--color-black);\n\n\t\tmargin-right: 4px;\n\t}\n\n\t.quantity-block {\n\t\theight: 24px;\n\t\twidth: 48px;\n\t\tbackground: #000000;\n\t\tborder: 1px solid;\n\t\tborder-radius: 50px;\n\t\tborder-image-source: linear-gradient(0deg, #ffffff, #ffffff), linear-gradient(0deg, #ffffff, #ffffff);\n\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\n\t\t.quantity {\n\t\t\tfont-family: Title;\n\t\t\tfont-weight: 400;\n\t\t\tfont-size: 20px;\n\t\t\tline-height: 120%;\n\t\t\tletter-spacing: 0%;\n\t\t\ttext-align: center;\n\t\t\tvertical-align: middle;\n\t\t\ttext-transform: uppercase;\n\t\t\tcolor: var(--color-white);\n\n\t\t\ttransform: translate(10px, -3%);\n\t\t}\n\n\t\t.checkmark {\n\t\t\theight: 24px;\n\t\t\twidth: 24px;\n\n\t\t\tposition: relative;\n\t\t\tleft: 2px;\n\t\t\tscale: 1.03;\n\t\t}\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
